export default __webpack_public_path__ + "0f45cf0b731a577a20886dbd5bf07618.wasm";